import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ShoppingBasket } from "lucide-react";
import { useApp } from "../context/AppContext";
import BrandLogo from "./BrandLogo";

const navItems = [
  { to: "/", label: "Beranda" },
  // { to: "/telang-rosella", label: "Telang & Rosella" },
  { to: "/tentang", label: "Tentang" },
  { to: "/kontak", label: "Kontak" },
  { to: "/riwayat", label: "Riwayat Checkout" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { cartCount, openCart } = useApp();

  const linkClass = ({ isActive }) =>
    `px-3 py-2 rounded-lg text-base font-medium transition ${
      isActive
        ? "bg-emerald-50 text-emerald-700"
        : "text-stone-600 hover:text-stone-900 hover:bg-stone-100"
    }`;

  return (
    <header
      className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-stone-200"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2"
          data-testid="nav-brand"
          onClick={() => setOpen(false)}
        >
          <BrandLogo className="h-10 w-10" padded />
          <span className="font-display text-xl font-semibold text-stone-900">
            Teras Alami
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={linkClass}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={openCart}
            className="relative inline-flex items-center justify-center w-11 h-11 rounded-xl border border-stone-200 text-stone-700 hover:bg-stone-100"
            aria-label="Keranjang"
            data-testid="nav-cart"
          >
            <ShoppingBasket className="w-5 h-5" />
            {cartCount > 0 && (
              <span
                className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 rounded-full bg-emerald-600 text-white text-xs font-semibold inline-flex items-center justify-center border-2 border-white"
                data-testid="nav-cart-count"
              >
                {cartCount}
              </span>
            )}
          </button>

          <button
            type="button"
            className="md:hidden w-11 h-11 rounded-xl border border-stone-200 flex items-center justify-center text-stone-700 hover:bg-stone-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-stone-200 bg-white"
          data-testid="nav-mobile-menu"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base font-medium ${
                    isActive
                      ? "bg-emerald-50 text-emerald-700"
                      : "text-stone-700 hover:bg-stone-100"
                  }`
                }
                data-testid={`nav-mobile-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
